/**
 * Lock icon colors for Sales Target (and similar patterns).
 * Use grey on light/table surfaces; white on solid buttons so brand fills are unchanged.
 */
export const LockIconGrey = "#868e96";

export const LockIconWhiteOnButton = "#ffffff";

/** Iconify `width` / `height` (px) — keep table + button locks visually aligned. */
export const LockIconSizeTable = 19;

export const LockIconSizeOnButton = 14;
